import React, { useState } from "react";
import { Box } from "@mui/material";
import { STRINGS } from "../strings";
import CustomModal from "../../../../components/Modals/CustomModal";
import { fontWeight } from "../../../../utils/constants/UI";
import { GREY, TEAL, SUCCESS } from "../../../../utils/constants/colors";
import { Button } from "../../../../components/Buttons";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import Image from "../../../../components/Image/Image";
import classes from "../markComponents.module.css";
import CreateAutomation from "./CreateAutomation";
import ChooseStepModal from "./ChooseStepModal";
import { ACTION_CRM, AI_ICON } from "../../../../utils/constants/assets";

export const SEQUENCE_STEP_TYPES = [
  {
    title: "Auto-Generated",
    description: "Let our AI handle the process automatically",
    bgColor: TEAL.W_50,
    iconComponent: AI_ICON,
    component: CreateAutomation,
  },
  {
    title: "Use Manual Creation",
    description: "Create steps manually with full control",
    bgColor: SUCCESS.W_50,
    iconComponent: ACTION_CRM,
    component: ChooseStepModal,
  },
];

const STYLES = {
  modalBody: {
    padding: "20px",
  },
  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px",
  },
  card: {
    base: {
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      borderRadius: "16px",
      border: `2px solid ${GREY.BORDER}`,
      transition: "all 0.2s ease",
      overflow: "hidden",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      },
    },
  },
  iconSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 24px 32px",
  },
  iconCircle: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  },
  icon: {
    width: "56px",
    height: "56px",
    display: "block",
  },
  textSection: {
    padding: "24px 24px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  buttonSection: {
    padding: "0 20px 20px",
  },
};

const SelectionAutomationOrManual = ({
  open,
  setOpen,
  stepNumber,
  reSubject,
  seqId,
  nextstep,
  foldId,
}) => {
  const [stepSelected, setStepSelected] = useState(null);
  const [openStepModal, setOpenStepModal] = useState(false);

  const handleEditorOpen = (step) => {
    setStepSelected(step);
    setOpenStepModal(true);
  };

  const handleClose = () => {
    setOpen(false);
    setStepSelected(null);
  };

  const SelectedComponent = stepSelected?.component;

  const modalHeaderData = {
    heading: {
      id: STRINGS.LISTID,
      label: "How would you like to create this step ?",
    },
  };

  const modalBodyData = (
    <Box sx={STYLES.modalBody}>
      <Box sx={STYLES.cardsContainer}>
        {SEQUENCE_STEP_TYPES.map((step) => {
          const isAutomation = step.bgColor === TEAL.W_50;

          return (
            <Box
              key={step.title}
              onClick={() => handleEditorOpen(step)}
              sx={STYLES.card.base}
            >
              <Box
                sx={{
                  ...STYLES.iconSection,
                  backgroundColor: step.bgColor,
                }}
              >
                <Box sx={STYLES.iconCircle}>
                  <Image
                    src={step.iconComponent}
                    alt={step.title}
                    style={STYLES.icon}
                  />
                </Box>
              </Box>

              <Box sx={STYLES.textSection}>
                <TypographyInline
                  size="md"
                  color={GREY.PRIMARY}
                  fontWeight={fontWeight.SEMIBOLD}
                  label={step.title}
                />
                <TypographyInline
                  size="sm"
                  color={GREY.QUATINARY}
                  fontWeight={fontWeight.REGULAR}
                  label={step.description}
                />
              </Box>

              <Box sx={STYLES.buttonSection}>
                <Button
                  label={step.title}
                  variant="primary"
                  size="sm36"
                  fullWidth
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditorOpen(step);
                  }}
                  sx={{
                    backgroundColor: isAutomation ? TEAL.W_500 : SUCCESS.W_500,
                    color: "white",
                    "&:hover": {
                      backgroundColor: isAutomation
                        ? TEAL.W_600
                        : SUCCESS.W_600,
                    },
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );

  return (
    <>
      <CustomModal
        open={open}
        close={() => setOpen(false)}
        header={modalHeaderData}
        width="800px"
      >
        {modalBodyData}
      </CustomModal>

      {openStepModal && SelectedComponent && (
        <SelectedComponent
          handleClose={handleClose}
          stepNumber={stepNumber}
          reSubject={reSubject}
          seqId={seqId}
          foldId={foldId}
          open={openStepModal}
          setOpen={setOpenStepModal}
        />
      )}
    </>
  );
};

export default SelectionAutomationOrManual;
